const shuffleArray = <T>(array: T[]): T[] => {
	return array
		.map((a) => [Math.random(), a] as [number, T])
		.sort((a, b) => a[0] - b[0])
		.map((a) => a[1]);
};

export default shuffleArray;
